<template>
  <div> 
    <modal v-on:cancel="handleModalResultCancel()" 
           v-on:ok="handleModalResultOK()"
           :showButtons="Ok" 
           v-if="showModal" v-bind:modalText="modalText"></modal>    
<!-- rounds scrollbar -->
    <div v-if="!showingPlayerResults">
      <div class="scrollAndButtons">
        <div class="scrollButton" @click="selectPreviousRound()"> <font-awesome-icon icon="chevron-left" /> </div> 
        <div class="scrollContainer" id="scrollable" v-on:scroll="handleScroll">
          <div class="dummyScrollItem"></div>
          <div v-for="round in rounds" 
              :key="round.roundId"
              :round="round"
              :id="'scrollItem' + round.number"
                class="scrollItem" @click="selectRound(round.number)">{{ $t('tournaments.round') }} {{round.number}}</div>
          <div class="dummyScrollItem"></div>
        </div>
        <div class="scrollButton" @click="selectNextRound()"> <font-awesome-icon icon="chevron-right" /> </div> 
      </div>
    </div>

<!-- errors, if any -->
    <div v-if="errorMessage" class="w3-panel errorBox w3-round">
      <font-awesome-icon icon="exclamation-circle" class="errorIcon w3-right"/>
      <div v-html="errorMessage"></div>
    </div>

<!-- match results -->
    <div class="pageSection" v-if="!showingPlayerResults">
      <addMatch v-on:cancel="handleAddMatchResultCancel" 
            v-on:ok="handleAddMatchResultOK" 
            v-if="showingAddMatchModal" 
            v-bind:participants="participants"
            v-bind:tournamentId="tournamentId"
            v-bind:roundId="roundId"
            v-bind:groupId="groupId"
            v-bind:action="'create'"></addMatch>    
      <div>
        
        <div v-if="managementFunctions">
          <button :class="{'button-icon-inactive square-icon': isPairingRound, 'button-icon square-icon w3-right': !isPairingRound}" v-if="canCreatePairing || true" href="#" :title="$t('tournament.createPairing')" @click="createPairing()"><font-awesome-icon icon="wrench" class="align-icon"/> {{ $t('tournament.createPairing') }}</button>
          <button :class="{'button-icon-inactive square-icon': isApprovingRound, 'button-icon square-icon w3-right': !isApprovingRound}" v-if="canApprovePairing" href="#" :title="$t('tournament.pairingApproved')" @click="approvePairing()"><font-awesome-icon icon="check" class="align-icon"/> {{ $t('tournament.pairingApproved') }}</button>
          <button :class="{'button-icon-inactive square-icon': isFinishingRound, 'button-icon square-icon w3-right': !isFinishingRound}" v-if="canFinishRound" href="#" :title="$t('tournament.finishRound')" @click="finishRound()"><font-awesome-icon icon="check" class="align-icon"/> {{ $t('tournament.finishRound') }}</button>
          <button class="button-icon  square-icon w3-right" v-if="canReopenRound" href="#" :title="$t('tournament.reopenRound')" @click="reopenRound()"><font-awesome-icon icon="unlock" class="align-icon"/> {{ $t('tournament.reopenRound') }}</button>
          {{ $t('tournaments.round') }} {{activeRoundNumber}}: {{ getRoundStatus }} 
        </div>
        <h2>{{ $t('tournaments.matches') }} in {{ $t('tournaments.round') }} {{activeRoundNumber}} ({{ getRoundDate }})</h2>
      </div>
      <div v-for="group in tournament.groups"
            :key="group.groupId"
            :group="group">
        <div v-if="tournament.groups.length > 1" ><font-awesome-icon icon="users" class=""/> {{group.name}}</div>
        <button class="button-icon square-icon w3-right" v-if="!statusPlayed && managementFunctions" href="#" title="add Match" @click="addMatch(group.groupId)"><font-awesome-icon icon="plus-square" class="align-icon"/> {{ $t('tournaments.match')}}</button>

        <table class="result-table"><tbody>
        <!--<tr><td>White</td><td></td><td>Black</td><td>Result</td><td>Actions</td></tr>-->
        <tr class="result-row" v-for="(match, index) in groupMatches(group.groupId)"
                                  :key="match.matchId" 
                                  :match="match">
          <td class="left">{{index + 1}}</td>

          <td class="middle" v-if="managementFunctions && !statusPlayed">
            <i :title="$t('match.fix')" :class="{'fa fa-check-square-o': isMatchFixed(index), 'fa fa-square-o': !isMatchFixed(index)}" @click="fixMatch(index)"></i>
          </td>

          <td class="right"><a href="#" @click="showParticipantResult(match.whitePlayer)">{{match.whitePlayer.person.name}} ({{match.whitePlayer.startingElo}})</a></td>
          <td class="middle">
            <div class="result-buttons" v-if="managementFunctions && !statusPlayed">
              <button 
                class="grid-btn" 
                :class="{ 'is-active': match.result === 1 }"
                @click="setMatchresult(index, 1)">
                <img src="@/assets/img/CA_KingMetalSmall_black.png" alt="white wins" class="grid-button-icon pushdown-two">
              </button> 

              <button 
                class="grid-btn" 
                :class="{ 'is-active': match.result === 3 }"
                @click="setMatchresult(index, 3)">
                <img src="@/assets/img/CA_DrawSmall_black.png" alt="draw" class="grid-button-icon pushup-two">
              </button>

              <button 
                class="grid-btn" 
                :class="{ 'is-active': match.result === 2 }"
                @click="setMatchresult(index, 2)">
                <img src="@/assets/img/CA_KingBlueSmall_black.png" alt="black wins" class="grid-button-icon pushdown-two">
              </button>
            </div>
            <div class="center" v-if="statusPlayed || !managementFunctions" v-html="showResult(match.result)"> </div>
          </td>
          <td class="floatLeft"><a href="#" @click="showParticipantResult(match.blackPlayer)">{{match.blackPlayer.person.name}} ({{match.blackPlayer.startingElo}})</a></td>
          <td class="result-cell-last">
            <button class="grid-btn" href="#" title="delete this match" v-if="managementFunctions && !statusPlayed" @click="deleteMatch(match.matchId)"><font-awesome-icon icon="trash" class="grid-button-icon"/></button>
          </td>
        </tr>
        <tr v-if="groupMatches(group.groupId).length == 0"><td colspan="4">{{ $t('tournaments.nopairing') }}</td></tr>
        </tbody></table>
      </div>
    </div>

<!-- absences -->
    <div class="pageSection" v-if="!showingPlayerResults">
      <addAbsenceModal v-on:cancel="handleAddAbsenceModalResultCancel" 
            v-on:ok="handleAddAbsenceModalResultOK" 
            v-if="showingAddAbsenceModal" 
            v-bind:absences="possibleAbsences"
            v-bind:roundId="roundId"
            v-bind:scores="absenceScores"></addAbsenceModal>    
      <div>
        <button class="button-icon square-icon w3-right" title="show absences" @click="toggleInputFields" v-show="showInputFields===false"><font-awesome-icon icon="caret-square-down" /></button>
        <button class="button-icon square-icon w3-right" title="hide absences" @click="toggleInputFields" v-show="showInputFields"><font-awesome-icon icon="caret-square-up" /></button>
        <button class="button-icon square-icon w3-right" href="#" title="add absence" v-if="managementFunctions && !statusPlayed" @click="addAbsence"><font-awesome-icon icon="plus-square" />{{  $t('tournaments.absence') }}</button>
        <h2>{{ $t('tournaments.absences') }} ({{absences.length}})</h2>
      </div>
      <div name="dummyGroupSection" v-if="showInputFields">
        <div v-if="absences.length == 0">{{ $t('tournaments.noAbsences') }}</div>
        <table v-if="absences.length > 0" class="result-table"><tbody>
          <tr class="result-header"><td>{{ $t('tournaments.name') }}</td><td>{{ $t('tournaments.reason') }}</td><td></td></tr>
          <tr class="result-row" v-for="absence in absences"
                                    :key="absence.absenceId" 
                                    :absence="absence">
            <td><a href="#" @click="showParticipantResult(absence.participant)">{{absence.participant.person.name}}</a></td><td>{{ reasonName(absence.reasonId)}}</td>
            <td class="result-cell-last">
              <button class="grid-btn" href="#" title="delete this absence" v-if="managementFunctions && !statusPlayed" @click="deleteAbsence(absence.absenceId)"><font-awesome-icon icon="trash" class="grid-button-icon"/></button>
            </td>
          </tr>
        </tbody></table>
      </div>
    </div>

<!-- rankings -->
    <ResultRankingKeizer  class="pageSection" v-if="!showingPlayerResults && tournament.tournamentTypeId == 2" 
      v-bind:tournament="tournament"
      v-bind:managementFunctions="managementFunctions"
      v-bind:activeRoundNumber="activeRoundNumber"
      v-bind:roundId="roundId"
      v-bind:rankings="rankings" /> 
    <ResultRankingSwiss  class="pageSection" v-if="!showingPlayerResults && tournament.tournamentTypeId == 1" 
      v-bind:tournament="tournament"
      v-bind:managementFunctions="managementFunctions"
      v-bind:activeRoundNumber="activeRoundNumber"
      v-bind:roundId="roundId"
      v-bind:rankings="rankings" /> 
    <ResultTPRRanking  class="pageSection" v-if="!showingPlayerResults && tournament.tournamentTypeId == 2" 
      v-bind:tournament="tournament"
      v-bind:managementFunctions="managementFunctions"
      v-bind:activeRoundNumber="activeRoundNumber"
      v-bind:roundId="roundId"
      v-bind:rankings="tprRankings" /> 
      
<!-- player results -->
    <div class="pageSection" v-if="showingPlayerResults">
      <button href="#" class="button-icon square-icon  w3-rightfloatRight" @click="showingPlayerResults=false">terug naar ronde resultaten</button><br/>
      <player-results 
          v-bind:participant="showParticipant"
          v-bind:rounds="rounds"
          :key=showKey
          @update-player="onUpdatePlayerResults"></player-results>
    </div>
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
import AddAbsenceModal from "@/components/tournaments/results/AddAbsenceModal";
import AddMatch from "@/components/tournaments/results/AddMatch";
import Modal from "@/components/Modal";
import moment from 'moment';
import PlayerResults from './PlayerResults.vue';
import ResultRankingKeizer from './ResultRankingKeizer.vue';
import ResultTPRRanking from './ResultTPRRanking.vue';
import ResultRankingSwiss from './ResultRankingSwiss.vue';
import { secureRequest } from '../../services/restapi-helper';

const apiName = 'api';

export default {
  name: 'Results',
  components: {AddAbsenceModal, AddMatch, Modal, PlayerResults, ResultRankingKeizer, ResultRankingSwiss, ResultTPRRanking},
  props: {
    roundNumber: String,
    tournamentId: String,
    managementFunctions: Boolean
  },
  data: function () {
    return {
      absences: [],
      absenceScores: [],
      activeRoundNumber: "1",
      activeScrollitem: "scrollItem1",
      approvingRound: false,
      errorMessage: "",
      finishingRound: false,
      groupId: -1,
      matches: [],
      modalText: "",
      pairingRound: false,
      participants: [],
      possibleAbsences: [],  // All participants minus current absences
      rankings: [],
      reasons: [{reasonId:"1", name:"absent with message"},
                {reasonId:"2", name:"absent without message"},
                {reasonId:"3", name:"absent for club"},
                {reasonId:"4", name:"manual bye"}],
      roundId: -1,
      rounds: [],
      roundComplete: false,
      roundSet: false,
      scrollInitiated: false,
      showingAddAbsenceModal: false,
      showingAddMatchModal: false,
      showingInputFields: true,
      showingModal: false,
      showingPlayerResults: false, //either all results, or playerresults
      showKey: 0,
      showParticipant: {participantId: -1},
      startedRoundPlay: false,
      tournament: {tournamentId:-1, name:''},
      tprRankings: []
    }
  },
  beforeMount() {
    if (this.roundNumber !=  null)
      this.activeRoundNumber = this.roundNumber;
    console.log("this.roundnumber: " + this.roundNumber);
    console.log("this.activeRoundNumber: " + this.activeRoundNumber);
    this.loadTournament();
    this.loadScores();
    this.loadParticipants();
  },
  updated() {
    if (!this.roundSet) {
      if (this.rounds.length > 0) {
        var firstActiveRoundNumber = this.determineActiveRound();
        console.log("firstActiveRoundNumber: " + firstActiveRoundNumber);
        console.log("this.activeRoundNumber-2: " + this.activeRoundNumber);
        this.selectRound(firstActiveRoundNumber);
      }
    }
  },
  computed: {
    canApprovePairing() {
      console.log("this.startedRoundPlay: "+ this.startedRoundPlay)
      return (this.statusPairing && !this.startedRoundPlay);
    },
    canCreatePairing() {
      //The arbiter can generate a pairing on the first planned Round available if the previous one has the status "Played"
      //The arbiter can also genarate a pairing after pairing already. Absences may have been removed or added. A
      //new pairing will optionally remove already entered matches. They may be seen as fixed.
      //When play has started, no pairing is allowed.
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      if (thisRound.length == 1) { // rounds loaded
        var enableCreatePairing = false;
        if (this.activeRoundNumber == 1) {
          enableCreatePairing = (thisRound[0].status == "Planned" || thisRound[0].status == "Pairing" || thisRound[0].status == "Pairing final");
        }
        else {
          var previousRound = this.rounds[this.activeRoundNumber - 2]; //0-based
          enableCreatePairing = previousRound.status == "Played" && 
                                (thisRound[0].status == "Planned" || thisRound[0].status == "Pairing" || thisRound[0].status == "Pairing final") &&
                                !this.startedRoundPlay;
        }

        return enableCreatePairing;
      } else 
        return false;
      
    },
    canFinishRound() {
      return ((this.statusPlaying || this.statusEdit || this.statusPairing) && this.roundComplete)
    },
    canReopenRound() {
      return this.statusPlayed;
    },
    isApprovingRound() {
      return this.approvingRound;
    },
    isFinishingRound() {
      return this.finishingRound;
    },
    isPairingRound() {
      return this.pairingRound;
    },
    showInputFields() {
      return this.showingInputFields;
    },
    showModal() {
      return this.showingModal;
    },
    showPlayerResults() {
      return this.showingPlayerResults;
    },
    getAbsenceScores() {
      return this.absenceScores;
    },
    getPossibleAbsences() {
      return this.possibleAbsences;
    },
    getRoundDate() {
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      if (thisRound.length == 1)  
        return moment(thisRound[0].date).format("DD MMM yyyy");
      else  
        return '';
    },
    getRoundStatus() {
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      if (thisRound.length == 1)  
        return thisRound[0].status;
      else  
        return false;
    },
    statusEdit: function() {
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      if (thisRound.length == 1)  
        return thisRound[0].status == "Edit";
      else
        return false;
    },
    statusPairing: function() {
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      if (thisRound.length == 1)  
        return thisRound[0].status == "Pairing";
      else
        return false;
    },
    statusPlanned: function() {
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      if (thisRound.length == 1)  
        return (thisRound[0].status == "Planned");
      else
        return false;
    },
    statusPlaying: function() {
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      if (thisRound.length == 1)  
        return thisRound[0].status == "Pairing final";
      else
        return false;
    },
    statusPlayed: function() {
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      if (thisRound.length == 1)  
        return thisRound[0].status == "Played";
      else
        return false;
    }
  },
  methods: {
    addAbsence() {
      this.showingAddAbsenceModal=true;
    },

    addMatch(groupIdSelected) {
      this.groupId = groupIdSelected;
      console.log('groupId set: ' + this.groupId);
      this.showingAddMatchModal=true;
    },

    approvePairing() {
    /* After pairing, the arbiter will check if everything has been done right. All absences were 
       input etc. Once the arbiters gives this go, pairing is final for this round. Notifications 
       will be sent */
      this.approvingRound = true;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: true,
      };
      this.errorMessage = "";
      this.errorMessage = false;
      console.log("approving...");
      let that = this;
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      let path = "/round/" + thisRound[0].roundId + "/approve-pairing";
      console.log("Path: " + path);
      secureRequest('post', 'api', path, myInit, this.$CAUser) 
        .then(response => {
          console.log('Pairing approved, mails sent.');
          that.rounds[that.activeRoundNumber-1] = response;
          that.approvingRound = false;
        })
        .catch(error => {
          that.errorMessage = "<b>" + error.response.data.message + "</b><br/>" + error.response.data.errors;
          console.log(error.response);
          that.approvingRound = false;
        });

    },

    calculateRanking() {
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false,
      };
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      let path = "/Ranking/calculate?roundId=" + thisRound[0].roundId;
      let that = this;
      secureRequest('post', 'api', path, myInit, this.$CAUser) 
        .then(response => {
          console.log('Rankings calculated.' + response);
          that.loadRankings();
        })
        .catch(error => {
          var message = error.response.data.message;
          this.modalText = '<b>fout bij het bepalen van de stand.</b> <br/> ' + message;
          this.showingModal=true;
        });
    },

    calculateTPRRanking() {
      this.tprRankings = JSON.parse(JSON.stringify(this.rankings));

      // sort by TPR gain 
      this.tprRankings = this.tprRankings.sort(function compare(a, b) {
        if (a.tprGain > b.tprGain)
          return -1;
        if (a.tprGain < b.tprGain)
          return 1;
        return 0;
        });
         
      // Fill out rank.
      for (let i = 0; i < this.tprRankings.length; i++) {
        this.tprRankings[i].rank = i+1;
      }
    },

    checkCompletenessResults() {
      var roundMatches = this.matches;
      var roundCompleted = true;
      this.startedRoundPlay = false;
      roundMatches.forEach(element => {
        if (element.result == null || element.result == "") {
          roundCompleted = false;
        } else {
          this.startedRoundPlay = true;
        }
      });

      this.roundComplete = roundCompleted;
      console.log("Is round complete: " + roundCompleted)
    },

    createPairing() {
      this.pairingRound = true;
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      let path = '/round/' + thisRound[0].roundId + '/pair' ;
      console.log("Path  " + path);
      let that = this;
      const localInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false, 
      };

      secureRequest('post', 'api', path, localInit, this.$CAUser) 
        .then(response => {
          console.log("Paired " + response);
          thisRound[0].status = "Pairing"; // don't want to reload entire round.
          console.log("round status " + thisRound[0].status);
          that.loadMatches();
          that.pairingRound = false;
        })
        .catch(error => {
          var message = error.response.data.message;
          this.modalText = '<b>fout bij het genereren van de indeling.</b> <br/> ' + message;
          this.showingModal=true;
          console.log("Error message: " + message);
          that.pairingRound = false;
        });
    },

    deleteAbsence: function(absenceId) {
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false,
      };
      let path = '/absence/' + absenceId;
      let that = this;
      console.log('Deleting absence: ' + absenceId);
      secureRequest('del', 'api', path, myInit, this.$CAUser) 
        .then(
          that.loadAbsences()
        )
        .catch(error => {
          console.log(error.response);
        });
        
      console.log('Absence deleted.');
    },

    deleteMatch: function(matchId) {
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false,
      };
      let path = '/match/' + matchId;
      let that = this;
      console.log('Deleting match: ' + matchId);
      secureRequest('del', 'api', path, myInit, this.$CAUser) 
        .then(response => {
          console.log('Succes.' + response);
          that.loadMatches();
        })
        .catch(error => {
          console.log(error.response);
        });
        
      console.log('Match deleted.');
    },

    determineActiveRound: function() {
      // Find Pairing or Pairing final status.
      var round;
      for (let i = 0; i < this.rounds.length; i++) {
        console.log("round checked: " + i);
        round = this.rounds[i];
        if (round.status == "Pairing" || round.status == "Pairing final" || round.status == "Planned")
          break;
        // only on status played will the counter increase.
      }
      console.log("Active round determined: " + round.number);
      return round.number;
    },

    finishRound() {
      this.finishingRound = true;
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      let path = '/round/' + thisRound[0].roundId + '/complete' ;
      console.log("Path  " + path);
      let that = this;
      const localInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: true, 
      };

      secureRequest('post', 'api', path, localInit, this.$CAUser) 
        .then(response => {
          console.log("Completed " + response);
          that.loadRounds();
          that.finishingRound = false;
        })
        .catch(error => {
          that.finishingRound = false;
          var message = error.response.data.message;
          this.modalText = '<b>De ronde kan niet worden afgesloten.</b> <br/> ' + message;
          this.showingModal=true;
          console.log("Error message: " + message);
        });

    },

    fixMatch(matchIndex) {
      // fix a match, so that a new pairing wil leave this match intact.
      if (this.matches[matchIndex].fixed != null) {
        if (this.matches[matchIndex].fixed == true)
          this.matches[matchIndex].fixed = false;
        else
          this.matches[matchIndex].fixed = true;
      }
      else
          this.matches[matchIndex].fixed = true;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.matches[matchIndex],
        response: false
      };
      let completePath = '/match/' + this.matches[matchIndex].matchId;
      secureRequest('put', 'api', completepath, myInit, this.$CAUser) 
        .then(response => {
          console.log ("match updated: " + response);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    getItembyRoundnumber: function(round) {
        if (round.number == this.activeRoundNumber)
          return round;
    },  

    groupMatches: function(groupId) {
      return this.matches.filter(m => m.groupId == groupId);
    },

    groupRankings: function(groupId) {
      return this.rankings.filter(m => m.groupId == groupId);
    },

    handleAddAbsenceModalResultCancel() {
      console.log('Action cancelled');
      this.showingAddAbsenceModal = false;
    },

    handleAddAbsenceModalResultOK() {
      this.showingAddAbsenceModal = false;
      this.loadAbsences();
    },

    handleAddMatchResultCancel() {
      console.log('Action cancelled');
      this.showingAddMatchModal = false;
    },

    handleAddMatchResultOK() {
      this.showingAddMatchModal = false;
      this.loadRounds();
      this.loadMatches();
    },

    handleModalResultCancel() {
      console.log('Action cancelled');
      this.showingModal = false;
    },

    handleModalResultOK() {
      console.log('Action ok-d');
      this.showingModal = false;
    },

    handleScroll() {
      if (this.scrollInitiated) {
        const div = document.getElementById("scrollable");
        console.log("roundset variable: " + this.roundSet)
        var activeItem = 1;
        var buttonWidth = (document.documentElement.clientWidth * 0.33) + 20; //156 in mijn voorbeeld
        
        if (div.scrollLeft > 10)
          activeItem = (((div.scrollLeft-10)/buttonWidth) + 1).toFixed(0);
        else 
          activeItem = 1;

        var nextScrollitem  = "scrollItem" + activeItem;
        if (nextScrollitem != this.activeScrollitem) {
          console.log("prevdiv : " + this.activeScrollitem);
          const prevDiv = document.getElementById(this.activeScrollitem);
          prevDiv.classList.remove("activeScrollItem");

          console.log("active: " + nextScrollitem);
          this.activeScrollitem = nextScrollitem;
          const nextDiv = document.getElementById(this.activeScrollitem);
          nextDiv.classList.add("activeScrollItem");

          this.activeRoundNumber = activeItem;
          this.loadMatches(); 
        } else {
          this.scrollInitiated = true;
        }
      }
    },

    isMatchFixed: function(matchIndex) {
      var retValue = false;

      if (this.matches[matchIndex].fixed != null) {
        if (this.matches[matchIndex].fixed == 1) {
          retValue = true;
        }
      }

      return retValue;
    },

    loadAbsences() {
      const myInit = { 
        response: false
      };
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      let completePath = '/absence?roundId=' + thisRound[0].roundId;
      let that = this;
      console.log ("pad voor absenties: " + completePath);
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.absences = response;
          //console.log ("absences loaded: " + JSON.stringify(response));
          that.setPossibleAbsences();
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("Error", JSON.stringify(error));
          }
        });
    },

    loadGroups: function() { //Can only be called after loadTournament
      const myInit = { 
        response: false
      };
      let completePath = '/tournament/' + this.$route.params.tournamentId + '/group';
      let that = this;
      console.log ("pad: " + completePath);
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.tournament.groups = response;
          console.log ("groups loaded: " + that.tournament.groups.length);
          that.loadRounds();
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadMatches() {
      const myInit = { 
        response: false,
      };
      let that = this;
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      let completePath = '/match?roundId=' + thisRound[0].roundId;
      if (thisRound.status == "Planned") {
        this.matches = [];
      } else {
        RestAPI
          .get(apiName, completePath, myInit)
          .then(response => {
            that.matches = response;
            that.loadRankings();
            that.checkCompletenessResults();
          })
          .catch(error => {
            if (error.status !== 404) {
              console.log("ERROR" + JSON.stringify(error));
            }
          });
        }
    },

    loadParticipants: function() {
      const myInit = { 
        response: false
      };
      let that = this;
      let completePath = '/tournament/' + this.tournamentId + '/participant';
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.participants = response;
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadRankings: function() {
      const myInit = { 
        response: false
      };
      let that = this;
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      let completePath = '/ranking?roundId=' + thisRound[0].roundId;
      console.log ("pad: " + completePath);
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.rankings = response;
          //console.log ("Rankings loaded." + JSON.stringify(response));
          this.loadAbsences();
          this.calculateTPRRanking();
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadRounds: function() { //Can only be called after loadTournament
      const myInit = { 
        response: false
      };
      let completePath = '/round?tournamentId=' + this.$route.params.tournamentId;
      let that = this;
      console.log ("pad voor ronden: " + completePath);
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.rounds = response;
          console.log ("rounds loaded: " + that.rounds.length);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("Error", JSON.stringify(error));
          }
        });
    },

    loadScores: function() { 
      const myInit = { 
        response: false
      };
      let completePath = '/score?absentOnly=true&tournamentId=' + this.$route.params.tournamentId;
      let that = this;
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.absenceScores = response;
          console.log ("scores loaded: " + JSON.stringify(that.absenceScores));
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("Error", JSON.stringify(error));
          }
        });
    },

    loadTournament: function() {
      const myInit = { 
        response: false
      };
      let completePath = '/tournament/' + this.$route.params.tournamentId;
      let that = this;
      console.log ("pad: " + completePath);
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.tournament = response;
          console.log ("tournament loaded: " + that.tournament);
          that.loadGroups();
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    onUpdatePlayerResults (participant) {
      console.log('showing new player' + JSON.stringify(participant));
      console.log(' old player' + JSON.stringify(this.showParticipant));
      this.showParticipant = participant;
      this.showKey++;
    },

    reasonName: function(reasonId) {
      var score = this.absenceScores.filter(item => item.scoreId == reasonId);
      return score[0].name;
    },

    reopenRound() {
      this.rounds[this.activeRoundNumber - 1].status = 'Edit';
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: true,
        body: this.rounds[this.activeRoundNumber - 1]
      };
      let completePath = '/round/' + this.roundId;
      console.log ("pad: " + completePath);
      secureRequest('put', 'api', completePath, myInit, this.$CAUser) 
        .then(response => {
          console.log ("Round reopened: " + response);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    selectNextRound() { // user clicked on the "previous" button
      if (this.activeRoundNumber < this.rounds.length) {
        var nextScrollitem  = "scrollItem" + (this.activeRoundNumber + 1);
        if (nextScrollitem != this.activeScrollitem || !this.roundSet) {
          const prevDiv = document.getElementById(this.activeScrollitem);
          prevDiv.classList.remove("activeScrollItem");

          this.activeRoundNumber = this.activeRoundNumber + 1;
          this.activeScrollitem = nextScrollitem;
          const nextDiv = document.getElementById(this.activeScrollitem);
          nextDiv.classList.add("activeScrollItem");

          this.setRound(this.activeRoundNumber);
          this.loadMatches();
        }
      }
    },

    selectPreviousRound() { // user clicked on the "previous" button
      if (this.activeRoundNumber > 1) {
        var nextScrollitem  = "scrollItem" + (this.activeRoundNumber - 1);
        if (nextScrollitem != this.activeScrollitem || !this.roundSet) {
          const prevDiv = document.getElementById(this.activeScrollitem);
          prevDiv.classList.remove("activeScrollItem");

          this.activeRoundNumber = this.activeRoundNumber - 1;
          this.activeScrollitem = nextScrollitem;
          const nextDiv = document.getElementById(this.activeScrollitem);
          nextDiv.classList.add("activeScrollItem");

          this.setRound(this.activeRoundNumber);
          this.loadMatches();
        }
      }
    },

    selectRound(roundNumber) { // user selected a round in the scrollbar.
      console.log("selecting round" + roundNumber);
      var nextScrollitem  = "scrollItem" + roundNumber;
      if (nextScrollitem != this.activeScrollitem || !this.roundSet) {
        const prevDiv = document.getElementById(this.activeScrollitem);
        prevDiv.classList.remove("activeScrollItem");
        console.log("selecting round 2" + roundNumber);

        this.activeRoundNumber = roundNumber;
        this.activeScrollitem = nextScrollitem;
        const nextDiv = document.getElementById(this.activeScrollitem);
        nextDiv.classList.add("activeScrollItem");

        this.setRound(roundNumber);
        this.loadMatches();
      }
    },    
    
    setMatchresult: function(matchIndex, result) {
      this.matches[matchIndex].result = result;
      const myInit = { 
        body: this.matches[matchIndex],
        response: false
      };
      let that = this;
      let completePath = '/match/' + this.matches[matchIndex].matchId;
      secureRequest('put', 'api', completePath, myInit, this.$CAUser) 
        .then(response => {
          console.log ("match updated: " + response);
          that.setRoundStatusAfterResult();
          that.calculateRanking();
          that.checkCompletenessResults();
        })
        .catch(error => {
          if (error.status !== 401) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    setPossibleAbsences() {
      // Return all participants (which are in the rankings), not found in the current absence list.
      //TODO: what if there is no ranking yet, huh?
      this.possibleAbsences = [];

      this.participants.forEach(participant => {
        var found = this.absences.filter(function(absence) {
          if(absence.participantId == participant.participantId) return participant;
        })
        if (found.length == 0)
          this.possibleAbsences.push(participant);
      }); 

      return this.possibleAbsences;
    },

    setRound(roundNumber) { // programmatic way to set the scrollbar right, when starting up this component.
      this.activeScrollitem = "scrollItem" + roundNumber;
      const activeItem = document.getElementById(this.activeScrollitem);
      console.log ("1active: " + activeItem.classList);
      activeItem.classList.add("activeScrollItem");
      console.log ("2active: " + this.activeScrollitem);

      const div = document.getElementById("scrollable");
      var buttonWidth = (document.documentElement.clientWidth * 0.33) + 20; //156 in mijn voorbeeld

      div.scrollLeft =  (buttonWidth * (roundNumber-1));

      console.log("RoundNumber: " + JSON.stringify(this.activeRoundNumber));      
      console.log("Round: " + JSON.stringify(this.rounds[this.activeRoundNumber-1]));
      this.roundId = this.rounds[this.activeRoundNumber-1].roundId;
      this.roundSet = true;

    },

    setRoundStatusAfterResult() {
      var thisRound = this.rounds.filter(this.getItembyRoundnumber);
      console.log ("round status now: " + thisRound[0].status);
      if (thisRound[0].status == "Pairing") 
        thisRound[0].status = "Pairing final"; 
    },

    showParticipantResult (participant) {
      console.log("trying to show participant: " + participant.participantId);
      this.showParticipant = participant;
      this.showingPlayerResults = true;
    },

    showResult(resultNumber) {
      var result = " - ";
      switch (resultNumber) {
        case 0:
          result = "";
          break;
        case 1:
          result = "1-0";
          break;
        case 2:
          result = "0-1";
          break;
        case 3:
          result = "&frac12;-&frac12;";
          break;
      }
      return result;
    },

    toggleInputFields () {
      this.showingInputFields = !this.showingInputFields;
    }
  }
}
</script>

<style scoped>

.btnInheader {
    font-size: 16px;
}

.pushup-two {
  padding-bottom: 2px;
}

.pushdown-two {
padding-top: 2px;
}

.center {
  text-align: center;
}

  .columnspace {
    padding-right: 16px;
  }

  .errorIcon {
    margin-top: 4px;
    margin-left: 8px;
  }

  .fa {
    color: #333333;
  }

  .fa:hover {
    color: #365c96; 
    transition: color .3s linear;
    cursor: pointer;
  }

  .fa-check-square-o {
    color: #c7ffeb;
  }

  .floatLeft {
    text-align: left;
  }

  .floatRight {
    text-align: right;
  }

  .groupSection {
    margin: 0vw 2vw;   
  }
  
  .imgbtn {
    text-decoration: none;
    float: right;
    border: 1px solid #333333;
    border-radius: 2px;
    margin-left: 4px;
  }

  .imgbtn-inactive {
    margin-left: 4px;
    float: right;
    border: 1px solid #333333;
    border-radius: 2px;
  }

  .imgbtn-inactive:hover {
    margin-left: 4px;
    float: right;
    border: 1px solid #333333;
    border-radius: 2px;
    color: #333333;
    cursor: default;
    pointer-events: none;
  }

  .dummyScrollItem {
    flex: 0 0 auto;
    height: 30px;
    line-height: 30px;
    scroll-snap-align: center;
    background-color: #333333;
    margin: 10px;
    text-align: center;
    vertical-align: middle;
  }
  
  .middle {
    width: 2%;
    padding: 0px 2px;
    white-space: nowrap;
  }

  .pageSection {
    margin-top: 2vw;
  }

  .selectbox {
  border: 1px solid #333333;
  border-radius: 2px;
  color: inherit;
  background-color: #333333;  
  padding-left: 4px;
  padding-right: 4px;
}

.selectbox:hover {
  border: 1px solid #365c96;
  transition: border .3s linear;
  border-radius: 2px;
  color: inherit;
  background-color: #333333;  
  padding-left: 4px;
  padding-right: 4px;
}
  
  .scrollButton {
    margin-top: 10px;
    cursor: pointer;
    height: 30px;
    line-height: 30px;
    background-color: #333333;  
    padding: 0vw 0.4vw;
  }

  .scrollButton:hover {
    color: #c7d5eb;
    transition: border .3s linear, color .3s linear, background-color .3s linear;
  }

  .scrollContainer {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
  }
  
  .scrollItem {
    flex: 0 0 auto;
    height: 30px;
    line-height: 30px;
    scroll-snap-align: center;
    background-color: #333333;
    margin: 10px;
    text-align: center;
    vertical-align: middle;
    border-radius: 2px;
    cursor: pointer;
  }
  
  .scrollItem:hover {
    color: #c7d5eb;
    text-decoration: underline;
    transition: border .3s linear, color .3s linear, background-color .3s linear;
  }
  
  .scrollItem.activeScrollItem {
    color: #007bff;
  }
  
  .scrollItem.activeScrollItem:hover {
    text-decoration: none;
    cursor:auto;
  }
  
  .scrollAndButtons {
    display: flex;
    flex-direction: row;
  }
  
  .scrollContainer::-webkit-scrollbar {
    display: none;
  }

  .tdSpace {
    margin: 0 2px;
  }

/* mobile */
@media screen and (max-width: 600px) {
  .container {
    padding: 2vw 0.5vw;
    width: 96vw;
  }

  .details {
    padding: 2vw;
  }

  .dummyScrollItem {
    width: 25vw;
  }

  .scrollItem {
    width: 33vw;
  }

  .visibleIfSpaceAvailable {
    display: none;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .container {
    padding: 2vw 0.5vw;
  }

  .details {
    padding: 1vw;
  }

  .dummyScrollItem {
    width: 0vw;
  }

  .scrollItem {
    width: 106px;
  }

  .visibleIfSpaceAvailable {
    display: table-cell;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .container {
    padding: 2vw 0.5vw;
  }

  .details {
    padding: 1vw;
  }

  .dummyScrollItem {
    width: 0vw;
  }

  .middle {
    padding-left: 8px;
    padding-right: 8px;
  }

  .scrollItem {
    width: 106px;
  }

  .visibleIfSpaceAvailable {
    display: table-cell;
  }
}

</style>
